var getFormattedAddressText = function getFormattedAddressText() {
  var mainText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var inputValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var line1MatchingUserInput = '';
  var line1Rest = mainText;

  if (line1Rest.length >= inputValue.length && line1Rest.toLowerCase().indexOf(inputValue.toLowerCase()) === 0) {
    line1MatchingUserInput = line1Rest.substring(0, inputValue.length);
    line1Rest = line1Rest.substring(inputValue.length);
  }

  return {
    line1MatchingUserInput,
    line1Rest
  };
};

var handleAutocomplete = function handleAutocomplete() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var setAutocomplete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};

  if (type === 'focus' || len > 3) {
    setAutocomplete('new-password');
  } else {
    setAutocomplete('');
  }
};

export { getFormattedAddressText, handleAutocomplete };